module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox-22eba5591581e8726e114416ad3b8caf.png";